import ClaimCard from './ClaimCard';
import ClaimCardLink from './ClaimCardLink';

export default Object.assign(ClaimCard, {
  Link: ClaimCardLink,
});
